// extracted by mini-css-extract-plugin
export default {"centralSectionContainer":"CentralSection_centralSectionContainer__d8mk2","centralSection":"CentralSection_centralSection__8TiLl"};